"use strict";

exports.__esModule = true;
exports.default = void 0;
require("core-js/modules/es.array.splice.js");
require("core-js/modules/es.array.index-of.js");
require("core-js/modules/es.object.assign.js");
var _utils = require("../utils");
var _use = (0, _utils.use)('swipe-item'),
  sfc = _use[0],
  bem = _use[1];
var _default = sfc({
  props: {
    adaptHeightItem: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      offset: 0
    };
  },
  beforeCreate: function beforeCreate() {
    this.$parent.swipes.push(this);
  },
  destroyed: function destroyed() {
    this.$parent.swipes.splice(this.index, 1);
  },
  computed: {
    index: function index() {
      return this.$parent.swipes.indexOf(this);
    }
  },
  render: function render(h) {
    var _this$$parent = this.$parent,
      vertical = _this$$parent.vertical,
      computedWidth = _this$$parent.computedWidth,
      computedHeight = _this$$parent.computedHeight,
      adaptHeight = _this$$parent.adaptHeight,
      active = _this$$parent.active,
      multiScrollerTab = _this$$parent.multiScrollerTab;
    var style = {
      width: computedWidth + 'px',
      height: vertical ? computedHeight + 'px' : '100%',
      transform: "translate" + (vertical ? 'Y' : 'X') + "(" + this.offset + "px)",
      minHeight: adaptHeight && this.adaptHeightItem ? computedHeight + 'px' : ''
    };
    if (multiScrollerTab) {
      style = {
        width: '100%',
        height: vertical ? computedHeight + 'px' : active === this.index ? 'auto' : 1,
        minHeight: adaptHeight && this.adaptHeightItem ? computedHeight + 'px' : ''
      };
    }
    return h("div", {
      "class": bem({
        image: adaptHeight && this.adaptHeightItem,
        active: active === this.index
      }),
      "style": style,
      "on": Object.assign({}, this.$listeners)
    }, [this.slots()]);
  }
});
exports.default = _default;